var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{class:'fake-link' + (_vm.additionalClasses ? ' ' + _vm.additionalClasses : ''),on:{"click":function($event){$event.stopPropagation();return _vm.$emit('click', $event)}}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }